export default "__VITE_ASSET__YYX3Q4Jh__"